import { Motorcycle } from '@material-ui/icons';
import { useMemo } from 'react';
import { PickupIcon, RVIcon, SedanIcon, SUVIcon, VanIcon } from 'shared/icons';
import { TrailerVehicleTypeIcon } from 'shared/icons/TrailerVehicleTypeIcon';
import { TruckIcon } from 'shared/icons/TruckIcon';
import { DriverPreferencesDTO } from 'shared/modules/driver/DriverPreferencesDTO';

const PREFERENCES_VEHICLE_TYPES_MAP = [
  { name: 'sedan', label: 'Sedan', icon: <SedanIcon fontSize="small" /> },
  { name: 'pickup', label: 'Pickup', icon: <PickupIcon fontSize="small" /> },
  {
    name: 'trailer',
    label: 'Trailer',
    icon: <TrailerVehicleTypeIcon fontSize="small" />,
  },
  { name: 'truck', label: 'Truck', icon: <TruckIcon fontSize="small" /> },
  { name: 'suv', label: 'SUV', icon: <SUVIcon fontSize="small" /> },
  { name: 'van', label: 'Van', icon: <VanIcon fontSize="small" /> },
  { name: 'rv', label: 'RV', icon: <RVIcon fontSize="small" /> },
  {
    name: 'motorcycle',
    label: 'Motorcycle',
    icon: <Motorcycle fontSize="small" />,
  },
];

export function useVehicleTypeItems(data?: DriverPreferencesDTO) {
  return useMemo(() => {
    const enclosedTrailerVehiclesList = [
      'sedan',
      'pickup',
      'suv',
      'motorcycle',
    ];

    if (data?.transport_type === 'driveaway') {
      return PREFERENCES_VEHICLE_TYPES_MAP.filter(
        (item) => item.name !== 'trailer',
      );
    } else if (
      data?.transport_type === 'truck' &&
      data.transport_trailer_type_is_enclosed === true
    ) {
      return PREFERENCES_VEHICLE_TYPES_MAP.filter((item) =>
        enclosedTrailerVehiclesList.includes(item.name),
      );
    }
    return PREFERENCES_VEHICLE_TYPES_MAP;
  }, [data?.transport_type, data?.transport_trailer_type_is_enclosed]);
}
